import { render, staticRenderFns } from "./JobSuva.vue?vue&type=template&id=2ba642ec&"
import script from "./JobSuva.vue?vue&type=script&lang=js&"
export * from "./JobSuva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports